// Directiva v-bloqueo-offline: con modoOffline deshabilita el elemento y todo lo que tiene dentro
// (anula click y submit en fase de captura). v-bloqueo-offline="false" la desactiva.
import { watch } from 'vue';
import { useConexion } from '@/stores';
import { MENSAJE_BLOQUEO_OFFLINE } from '@/config/offline';

const CLASE = 'zapi-bloqueado-offline';
const EVENTOS = ['click', 'submit'];

function anularEvento(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}

function actualizar(el) {
  const estado = el._bloqueoOffline;
  const bloquear = estado.activo && estado.conexion.modoOffline;
  if (bloquear && !estado.aplicado) {
    estado.aplicado = true;
    estado.titlePrevio = el.getAttribute('title');
    el.setAttribute('title', MENSAJE_BLOQUEO_OFFLINE);
    el.classList.add(CLASE);
    EVENTOS.forEach(ev => el.addEventListener(ev, anularEvento, true));
  } else if (!bloquear && estado.aplicado) {
    estado.aplicado = false;
    if (estado.titlePrevio === null) el.removeAttribute('title');
    else el.setAttribute('title', estado.titlePrevio);
    el.classList.remove(CLASE);
    EVENTOS.forEach(ev => el.removeEventListener(ev, anularEvento, true));
  }
}

export const bloqueoOffline = {
  mounted(el, binding) {
    const conexion = useConexion();
    el._bloqueoOffline = { conexion, activo: binding.value !== false, aplicado: false, titlePrevio: null };
    el._bloqueoOffline.detener = watch(() => conexion.modoOffline, () => actualizar(el), { immediate: true });
  },
  updated(el, binding) {
    el._bloqueoOffline.activo = binding.value !== false;
    actualizar(el);
    // Si Vue reescribió la clase del elemento al re-renderizar, se vuelve a poner
    if (el._bloqueoOffline.aplicado) el.classList.add(CLASE);
  },
  unmounted(el) {
    el._bloqueoOffline.detener();
    el._bloqueoOffline.activo = false;
    actualizar(el);
    delete el._bloqueoOffline;
  }
};
